class BranchStorage {
  constructor() {
    this.LOCAL_STORAGE_BRANCH = "branch-info";
    this.LOCAL_STORAGE_BRANCH_UUID = "branch-uuid";
  }

  get branchUUID() {
    return localStorage.getItem(this.LOCAL_STORAGE_BRANCH_UUID);
  }
  set branchUUID(data) {
    localStorage.setItem(this.LOCAL_STORAGE_BRANCH_UUID, data);
  }

  get branchInfo() {
    return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_BRANCH));
  }
  set branchInfo(data) {
    localStorage.setItem(this.LOCAL_STORAGE_BRANCH, JSON.stringify(data));
  }
}

export default new BranchStorage();